import { FilterBuilder } from '../Types';

import { CanonicalFurniture } from 'ha/constants/Filters';

const furnitureBuilder: FilterBuilder = params => {
  const furniture = params.furniture;

  if (!furniture) {
    return '';
  }

  return {
    [CanonicalFurniture.Furnished]: 'facility_bedroom_furnished:yes',
    [CanonicalFurniture.Unfurnished]: 'facility_bedroom_furnished:no',
  }[furniture];
};

export default furnitureBuilder;
